import React, { useState, useEffect, useRef } from "react"
import Button from "react-bootstrap/esm/Button"
import { completeChemoOrder, getAllConsultants, getAllRMO, getMedicalRecordByAppointmentId, uploadSpecificFile } from "../../../../core/services/api"
import Toast from "../../../Toast"
import Dropdown from "components/DropDown"
import { useSelector } from "react-redux"
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import moment from "moment"
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader"
import testLabels from "components/FollowUpVisit/testLabels.json"
import { getVitals } from "core/services/api/patientDiagnosisService"
import Print from "components/Print/Print"

type AddToPrintType = {
  preMedication: boolean;
  chemotherapy: boolean;
  takeHomeMedicine: boolean;
  testsToBeDone: boolean;
};


function AccordianOrderDetail({ values, isCompleted, patientInfo, handleChemoOrderCompletion, type, readOnly, smartSummaryData, appointmentDate }: any) {

  const [addToPrint, setAddToPrint] = useState<AddToPrintType>({ preMedication: true, chemotherapy: true, takeHomeMedicine: true, testsToBeDone: true })
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const componentRef: any = useRef<any>(null);
  const ecogStatusNumber = values?.ecogStatus?.match(/\d+/);
  // Define a CSS class for hiding elements when printing
  const printHidden = 'd-print-none';
  const templateJSON = {
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "consultantSign",
            "title": ".",
            "hideNumber": true,

          },
        ]
      }
    ],
    "showNavigationButtons": "none",
    "showPageTitles": false,
    "showCompletedPage": false
  }

  const [displayToast, toggleDisplayToast] = useState<any>()
  const [selectedSign, setSelectedSign] = useState<any>()
  const [selectedSignRMO, setSelectedSignRMO] = useState<any>()
  const [consultants, setConsultants] = useState<any>()
  const [RMO, setRMO] = useState<any>()
  const [consultantOptions, setConsultantOptions] = useState<any>([])
  const [rmoOptions, setrmoOptions] = useState<any>([])
  const [signatureData, setSignatureData] = useState<any>({})
  const [signatureDataRMO, setSignatureDataRMO] = useState<any>({})
  const [signatureJson, setSignatureJson] = useState<any>(templateJSON)
  const [vitalsData, setVitalsData] = useState<any>({})

  //Loader
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    fetchConsultants()
    fetchRMO()
  }, [])


  useEffect(() => {
    if (values?.appointmentId) {
      getMedicalRecordByAppointmentId(values?.appointmentId)
        .then((response: any) => {
          const recordId = response?.id
          if (recordId) {
            getVitals(recordId, true)
              .then((data: any) => {
                const res = data.data
                setVitalsData(res)
              })
              .catch((err: any) => {
                console.log(err)
              })
          }
        })
        .catch((err: any) => {
          console.log("error in fetching record", err)
        })
    }
  }, [values])


  console.log(values?.testsToBeDone)
  useEffect(() => {
    if (values?.consultantSign) {
      const found = consultants?.find((each: any) => each?.signaturePicUrl === values?.consultantSign)
      if (found) {
        setSelectedSign(found?.name)
      } else if (values?.consultantSign) {
        setSignatureData({
          consultantSign: values?.consultantSign
        })
      }
    }
    if (values?.rmoSign) {
      console.log(values?.rmoSign, "value of rmo Sign");
      setSelectedSignRMO(values?.rmoSign);
      setSignatureDataRMO({
        consultantSign: values?.rmoSign
      })
      // const found = RMO?.find((each: any) => each?.signaturePicUrl === values?.rmoSign)
      // if (found) {
      //   setSelectedSignRMO(found?.name)
      // }
    }

  }, [consultants, values, RMO])

  //For Consultant
  useEffect(() => {
    if (selectedSign) {
      const found = consultants?.find((ele: any) => ele?.name === selectedSign)
      if (found) {
        const values = { ...signatureData }
        values["consultantSign"] = found?.signaturePicUrl
        setSignatureData(values)
        setSelectedSign(found?.name)
      }
    }
  }, [consultants, selectedSign])

  //For RMO
  useEffect(() => {
    if (selectedSignRMO) {
      const found = RMO?.find((ele: any) => ele?.name === selectedSignRMO)
      if (found) {
        const values = { ...signatureData }
        values["rmoSign"] = found?.signaturePicUrl
        setSignatureDataRMO(values)
        setSelectedSignRMO(found?.name)
      }
    }
  }, [consultants, selectedSign])

  const updateSurveyData = (data: any, survey: any) => {
    setSignatureData(data)
  }

  const updateSurveyDataRMO = (data: any, survey: any) => {
    setSignatureDataRMO(data)
  }

  const uploadFile = async (key: string, url: string): Promise<string> => {
    return new Promise<string>(async (resolve, reject) => {
      if (!url?.includes("http")) {
        try {
          const response = await fetch(url);
          const data = await response.blob();
          const metadata = {
            type: "image/png"
          };
          const file = new File([data], `${key}.png`, metadata);
          const formData = new FormData();
          formData.append('files', file);
          const uploadedFiles = await uploadSpecificFile(formData, true);
          resolve(uploadedFiles[0]);
        } catch (err: any) {
          console.error("Error in uploading file", err);
          if (err.response?.data?.code === 'MaxUploadSizeExceededException') {
            toggleDisplayToast({ text: "File Size should be less than 1 MB", type: "warning" });
          }
          reject(err);
        }
      }
      else {
        return url;
      }
    });
  };

  function fetchConsultants() {
    getAllConsultants(`/consultants?centerId=${userDetail?.currentCenter?.centerId}`)
      .then((res: any) => {
        setConsultants(res)
        const temp = res.map((ele: any) => {
          return ele?.name
        })

        setConsultantOptions(temp)
      })
      .catch((err) => {
        console.log("Err", err)
      })
  }

  function fetchRMO() {
    getAllRMO(userDetail?.currentCenter?.centerId)
      .then((res: any) => {
        setRMO(res)
        const temp = res.map((ele: any) => {
          return ele?.name
        })

        setrmoOptions(temp)
      })
      .catch((err) => {
        console.log("Err", err)
      })
  }

  useEffect(() => {
    if (readOnly) {
      const tempJson: any = { ...templateJSON }
      tempJson["pages"][0]["readOnly"] = true
      tempJson["showNavigationButtons"] = "none"
      setSignatureJson(tempJson)
    }
  }, [readOnly])

  async function completeChemOrder() {
    if (!signatureData?.consultantSign) {
      toggleDisplayToast({ text: "Please select the consultant sign", type: "error" })
    } else {
      const blobUrlRMO = await uploadFile("rmoSign", signatureDataRMO?.consultantSign);
      const finalData = {
        consultantSign: signatureData?.consultantSign,
        rmoSign: blobUrlRMO
      }
      // setIsLoading(true)
      completeChemoOrder(finalData, values?.id)
        .then((res: any) => {
          setIsLoading(false)
          toggleDisplayToast({ text: "Chemo Order Completed Successfully", type: "success" })

        })
        .catch((err: any) => {
          setIsLoading(false)
          toggleDisplayToast({ text: "Unable to Complete Chemo Order", type: "error" })
        })
    }
  }


  return (
    <div className="accordian-details-general" ref={componentRef} >
      {
        isLoading && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="print-only">
        <PatientDetailsPrintHeader
          patientData={{ patientInfo: patientInfo, vitalsData: null }}
          smartSummaryData={smartSummaryData}
          appointmentDate={appointmentDate}
        />
      </div>
      <div className="chemo-heading"> Chemo Order Details</div>
      {/* <div className="patient-info-print">{patientInfo?.name}-{patientInfo?.mocId}-{patientInfo?.gender}-{patientInfo?.age}</div> */}
      {displayToast && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9998,
          }}
        >
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => {
              toggleDisplayToast(false);
              if (displayToast?.type === "success") {
                handleChemoOrderCompletion(true);
                // window.location.reload();
                // setrefresh((current: any) => !current);
              }
            }}
            onCloseText="Close"
            onClickText={null}
          />
        </div>

      )}
      {/* Chemo order details for screen */}
      <div
        className="chemo-extra-details screen-only"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <div
          className={`accordian-details-sub ${!values?.chemoOrderForDate ? "print-hidden" : ""}`}
        >
          <div className="details-general-sub-label">Chemo Order Date:</div>
          <div className="details-general-sub-value "> {values?.chemoOrderForDate ? moment(values?.chemoOrderForDate)?.format("DD-MM-YYYY") : "-"}</div>
        </div>

        <div
          style={{ display: "flex", columnGap: "10px" }}
        >
          <div
            style={{ width: "50%" }}
            className={`accordian-details-sub ${!values?.diagnosis ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">Diagnosis:</div>
            <div className="details-general-sub-value ">{values?.diagnosis}</div>
          </div>
          <div
            className={`accordian-details-sub ${!values?.locationDetails ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">Location:</div>
            <div className="details-general-sub-value ">{values?.locationDetails}</div>
          </div>
        </div>

        <div
          style={{ display: "flex", columnGap: "10px" }}
        >
          <div
            style={{ width: "50%" }}
            className={`accordian-details-sub ${!values?.lineOfTreatment ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">
              Line Of Treatment:
            </div>
            <div className="details-general-sub-value "> {values?.lineOfTreatment}
            </div>
          </div>
          <div
            className={`accordian-details-sub ${!values?.ecogStatus ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">ECOG Status:</div>
            <div className="details-general-sub-value " id="ecogStatus">
              {
                values?.ecogStatus?.split(" - ")?.length > 0 ?
                  values?.ecogStatus?.split(" - ")[0]
                  :
                  ""
              }
            </div>
          </div>
        </div>

        <div
          style={{ display: "flex", columnGap: "10px" }}
        >
          {/* <div
            style={{ width: "50%" }}
            className={`accordian-details-sub ${!values?.chemoTemplate ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">
              Chemo Template:
            </div>
            <div className="details-general-sub-value">
              {values?.chemoTemplate}
            </div>
          </div> */}
          <div
            className={`accordian-details-sub ${!values?.regimen ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">Regimen:</div>
            <div className="details-general-sub-value "> {values?.regimen}</div>
          </div>
        </div>

        <div
          style={{ display: "flex", columnGap: "10px" }}
        >
          <div
            style={{ width: "32%" }}
            className={`accordian-details-sub ${!values?.cycleNo ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">
              Cycle No:
            </div>
            <div className="details-general-sub-value ">
              {values?.cycleNo}
            </div>
          </div>
          <div
            style={{ width: "32%" }}
            className={`accordian-details-sub ${!values?.week ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">
              Week:
            </div>
            <div className="details-general-sub-value ">
              {values?.week}
            </div>
          </div>
          <div
            className={`accordian-details-sub ${!values?.day ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">
              Day:
            </div>
            <div className="details-general-sub-value ">
              {values?.day}
            </div>
          </div>
        </div>

        <div
          style={{ display: "flex", columnGap: "10px" }}
        >
          <div
            style={{ width: "50%" }}
            className={`accordian-details-sub ${!values?.toxicity ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">Toxicity:</div>
            <div className="details-general-sub-value ">{values?.toxicity}</div>
          </div>
          <div
            className={`accordian-details-sub ${!values?.sideEffects ? "print-hidden" : ""}`}
          >
            <div className="details-general-sub-label">Side Effects:</div>
            <div className="details-general-sub-value">
              {values?.sideEffects}
            </div>
          </div>
        </div>
      </div>
      {/* Chemo order details for print */}
      <div
        className="chemo-extra-details print-only"
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        {
          values?.chemoOrderForDate && (
            <div
              className={`accordian-details-sub ${!values?.chemoOrderForDate ? "print-hidden" : ""}`}
            >
              <div className="details-general-sub-label">Chemo Order Date:</div>
              <div className="details-general-sub-value "> {values?.chemoOrderForDate ? moment(values?.chemoOrderForDate)?.format("DD-MM-YYYY") : "-"}</div>
            </div>
          )
        }
        {
          values?.diagnosis && (
            <div
              className={`accordian-details-sub ${!values?.diagnosis ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Diagnosis:</div>
              <div className="details-general-sub-value ">{values?.diagnosis}</div>
            </div>
          )
        }
        {
          values?.locationDetails && (
            <div
              className={`accordian-details-sub ${!values?.locationDetails ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Location:</div>
              <div className="details-general-sub-value ">{values?.locationDetails}</div>
            </div>
          )
        }
        {
          (values?.lineOfTreatment || values?.ecogStatus) && (
            <div
              style={{ display: "flex", columnGap: "50px" }}
            >
              {
                values?.lineOfTreatment && (
                  <div
                    className={`accordian-details-sub ${!values?.lineOfTreatment ? "print-hidden" : ""}`}

                  >
                    <div className="details-general-sub-label">
                      Line Of Treatment:
                    </div>
                    <div className="details-general-sub-value "> {values?.lineOfTreatment}
                    </div>
                  </div>
                )
              }
              {
                values?.ecogStatus && (
                  <div
                    className={`accordian-details-sub ${!values?.ecogStatus ? "print-hidden" : ""}`}

                  >
                    <div className="details-general-sub-label">ECOG Status:</div>
                    <div className="details-general-sub-value " id="ecogStatus">
                      {
                        values?.ecogStatus?.split(" - ")?.length > 0 ?
                          values?.ecogStatus?.split(" - ")[0]
                          :
                          ""
                      }
                    </div>
                  </div>
                )
              }
            </div>
          )
        }
        {/* {
          values?.chemoTemplate && (
            <div
              className={`accordian-details-sub ${!values?.chemoTemplate ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">
                Chemo Template:
              </div>
              <div className="details-general-sub-value">
                {values?.chemoTemplate}
              </div>
            </div>
          )
        } */}
        {
          values?.regimen && (
            <div
              className={`accordian-details-sub ${!values?.regimen ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Regimen:</div>

              <div className="details-general-sub-value "> {values?.regimen}</div>
            </div>
          )
        }

        {
          (values?.cycleNo || values?.week || values?.day) && (
            <div
              style={{ display: "flex", columnGap: "50px" }}
            >
              {
                values?.cycleNo && (
                  <div
                    className={`accordian-details-sub ${!values?.cycleNo ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">
                      Cycle No:
                    </div>
                    <div className="details-general-sub-value ">
                      {values?.cycleNo}
                    </div>
                  </div>
                )
              }
              {
                values?.week && (
                  <div
                    className={`accordian-details-sub ${!values?.week ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">
                      Week:
                    </div>
                    <div className="details-general-sub-value ">
                      {values?.week}
                    </div>
                  </div>
                )
              }
              {
                values?.day && (
                  <div
                    className={`accordian-details-sub ${!values?.day ? "print-hidden" : ""}`}
                  >
                    <div className="details-general-sub-label">
                      Day:
                    </div>
                    <div className="details-general-sub-value ">
                      {values?.day}
                    </div>
                  </div>
                )
              }
            </div>
          )
        }
        {
          values?.toxicity && (
            <div
              className={`accordian-details-sub ${!values?.toxicity ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Toxicity:</div>
              <div className="details-general-sub-value ">{values?.toxicity}</div>
            </div>
          )
        }
        {
          values?.sideEffects && (
            <div
              className={`accordian-details-sub ${!values?.sideEffects ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Side Effects:</div>
              <div className="details-general-sub-value">
                {values?.sideEffects}
              </div>
            </div>
          )
        }
      </div>
      {/* Vitals */}
      {(values.isActive || values.isCompleted) && vitalsData && (
        <>
          <div className={`addition ${testLabels?.some((eachKey: any) => vitalsData[`${eachKey?.field}`]) ? "create-heading vital-label" : "print-hidden-co create-heading vital-label"}`}>Vitals</div>
          <ul className="prev-cn-vital">
            {
              testLabels?.map((item: any, viIndex: any) => {
                const value = vitalsData?.[item?.field];
                return value ? (
                  <li className="prev-cn-vital-item" key={viIndex}>
                    <span className="prev-cn-label">{item?.label}:</span>&nbsp;
                    <span>{value}</span>&nbsp;
                    <span>{item?.units}</span>&nbsp;
                  </li>
                ) : null;
              })
            }
          </ul>
        </>
      )
      }
      {/* Pre Medication */}
      <div className={`${addToPrint.preMedication ? "" : "print-hidden"}`}>
        <div className="d-flex justify-content-between align-items-center">
          <div
            className={`create-heading ${values?.preMedications?.some((outer: any) => {
              return outer?.medicines?.some((inner: any) => inner?.medicineName);
            }) ? "" : "print-hidden"}`}
          >
            PreMedication
          </div>
          <div className="print-hidden add-to-print">
            <input
              type="checkbox"
              className="add-to-print-checkbox"
              checked={addToPrint.preMedication}
              onChange={(e: any) => {
                const tempAddToPrint = { ...addToPrint }
                tempAddToPrint.preMedication = !addToPrint.preMedication
                setAddToPrint(tempAddToPrint)
              }}
            />
            <span>
              Add to print
            </span>
          </div>
        </div>
        <table
          className={`procedure-table ${values?.preMedications?.some((outer: any) => {
            return outer?.medicines?.some((inner: any) => inner?.medicineName);
          }) ? "" : "print-hidden"}`}
        >
          {values?.preMedications?.map((val: any, i: any) => {
            return <>
              <tr className={`heading-procedures ${val?.isCancelled ? "print-hidden" : ""}`}>
                <th>Sr.no</th>
                <th>Type</th>
                <th>Medicine</th>
                <th>Dose</th>
                <th>When</th>
                <th>Route</th>
                <th>Notes/Instructions</th>
                <th>Duration</th>
                <th>Side Effects</th>
              </tr>
              {val?.medicines?.map((item: any, j: any) => {
                return (
                  <tbody>
                    <tr className={`procedure-data ${val?.isCancelled ? "print-hidden" : ""}`}>
                      <td>{j + 1}</td>
                      <td>{item?.type}</td>
                      <td>{item?.medicineName}</td>
                      <td>{item?.dose}</td>
                      <td>{item?.when}</td>
                      <td>{item?.route}</td>
                      <td>{item?.instructions}</td>
                      <td>{item?.duration}</td>

                      <td>
                        <ul>
                          {item?.selectedSideEffects?.map(
                            (sideEffect: any) => {
                              return <li>{sideEffect}</li>
                            }
                          )}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                )
              })}
            </>
          })}

        </table>
      </div>
      {/* Chemotherapy Administration */}
      <div className={`${addToPrint.chemotherapy ? "" : "print-hidden"}`}>
        <div className="d-flex justify-content-between align-items-center">
          <div
            className={`create-heading ${values?.chemotherapyAdministration?.some((outer: any) => {
              return outer?.medicines?.some((inner: any) => inner?.medicineName);
            }) ? "" : "print-hidden"}`}
          >
            ChemoTherapy Administration
          </div>
          <div className="print-hidden add-to-print">
            <input
              type="checkbox"
              className="add-to-print-checkbox"
              checked={addToPrint.chemotherapy}
              onChange={(e: any) => {
                const tempAddToPrint = { ...addToPrint }
                tempAddToPrint.chemotherapy = !addToPrint.chemotherapy
                setAddToPrint(tempAddToPrint)
              }}
            />
            <span>
              Add to print
            </span>
          </div>
        </div>
        <table
          className={`procedure-table ${values?.chemotherapyAdministration?.some((outer: any) => {
            return outer?.medicines?.some((inner: any) => inner?.medicineName);
          }) ? "" : "print-hidden"}`}
        >
          {values?.chemotherapyAdministration?.map((val: any, i: any) => {
            return <>
              <tr className={`heading-procedures ${val?.isCancelled ? "print-hidden" : ""}`}>
                <th>Sr.no</th>
                <th>Type</th>
                <th>Medicine</th>
                <th>Dose</th>
                <th>Standard <br />Dose</th>
                <th>Dose <br />Modification</th>
                <th>Route</th>
                <th>Notes/ <br />Instructions</th>
                <th>Duration</th>
                <th>Side <br />Effects</th>
              </tr>
              {val?.medicines?.map((item: any, j: any) => {
                return (
                  <tbody>
                    <tr className={`procedure-data ${val?.isCancelled ? "print-hidden" : ""}`}>
                      <td>{j + 1}</td>
                      <td style={{ paddingRight: "10px" }}>{item?.type}</td>
                      <td>{item?.medicineName}</td>
                      <td>{item?.dose}</td>
                      <td>{item?.standardDose}</td>

                      <td>{item?.doseModification}</td>
                      <td>{item?.route}</td>
                      <td>{item?.instructions}</td>
                      <td>{item?.duration}</td>
                      <td>
                        <ul>
                          {item?.selectedSideEffects?.map(
                            (sideEffect: any) => {
                              return <li>{sideEffect}</li>
                            }
                          )}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                )
              })}
            </>
          })}

        </table>

      </div>
      {/* Take Home Medication */}
      <div className={`${addToPrint.takeHomeMedicine ? "" : "print-hidden"}`}>
        <div className="d-flex justify-content-between align-items-center">
          <div
            className={`create-heading ${values?.takeHomeMedicines?.some((outer: any) => {
              return outer?.medicines?.some((inner: any) => inner?.medicineName);
            }) ? "" : "print-hidden"}`}
          >
            Take Home Medicines
          </div>
          <div className="print-hidden add-to-print">
            <input
              type="checkbox"
              className="add-to-print-checkbox"
              checked={addToPrint.takeHomeMedicine}
              onChange={(e: any) => {
                const tempAddToPrint = { ...addToPrint }
                tempAddToPrint.takeHomeMedicine = !addToPrint.takeHomeMedicine
                setAddToPrint(tempAddToPrint)
              }}
            />
            <span>
              Add to print
            </span>
          </div>
        </div>
        <table
          className={`home-medication-table ${values?.takeHomeMedicines?.some((outer: any) => {
            return outer?.medicines?.some((inner: any) => inner?.medicineName);
          }) ? "" : "print-hidden"}`}
        >
          {values?.takeHomeMedicines?.map((val: any, i: any) => {
            return <>
              <thead>
                <tr className={`heading-procedures ${val?.isCancelled ? "print-hidden" : ""}`}>
                  <th>Sr.no</th>
                  <th>Type</th>
                  <th>Medicine</th>
                  <th>Dose</th>
                  <th>When</th>
                  <th>Frequency</th>
                  <th>Duration</th>
                  <th>Notes/Instructions</th>
                  <th>Side Effects</th>
                </tr>
              </thead>
              {val?.medicines?.map((item: any, j: any) => {
                return (
                  <tbody>
                    <tr className={`procedure-data ${val?.isCancelled ? "print-hidden" : ""}`}>
                      <td>{j + 1}</td>
                      <td>{item?.type}</td>
                      <td>{item?.medicineName}</td>
                      <td>{item?.dose}</td>
                      <td>{item?.when}</td>
                      <td>{item?.frequency}</td>
                      <td>{item?.duration}</td>
                      <td>{item?.instructions}</td>
                      <td>
                        <ul>
                          {item?.selectedSideEffects?.map(
                            (sideEffect: any) => {
                              return <li>{sideEffect}</li>
                            }
                          )}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                )
              })}
            </>
          })}

        </table>
      </div>
      {/* Chemo order details for print */}
      <div
        className="chemo-extra-details"
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        {
          values?.cycleFrequency && (
            <div
              className={`accordian-details-sub ${!values?.cycleFrequency ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Cycle Frequency:</div>
              <div className="details-general-sub-value">
                {values?.cycleFrequency}
              </div>
            </div>
          )
        }
        {
          values?.procedureNotes && (
            <div
              className={`accordian-details-sub ${!values?.procedureNotes ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Procedure Notes:</div>
              <div className="details-general-sub-value textarea-content">
                {values?.procedureNotes}
              </div>
            </div>
          )
        }
        {
          values?.clinicalNotes && (
            <div
              className={`accordian-details-sub ${!values?.clinicalNotes ? "print-hidden" : ""}`}

            >
              <div className="details-general-sub-label">Clinical Notes:</div>
              <div className="details-general-sub-value textarea-content">
                {values?.clinicalNotes}
              </div>
            </div>
          )
        }
      </div>
      {/* Follow Up */}
      <div
        className={`accordian-details-sub ${!values?.followUpDate ? "print-hidden" : ""}`}
      >
        <div className="details-general-sub-label">
          Follow up on:
        </div>
        <div className="details-general-sub-value">
          {values.followUpDate ? moment(values.followUpDate).format("DD-MM-YYYY") : ''}
        </div>
      </div>
      {/* Next Cycle Date */}
      <div
        className={`accordian-details-sub ${!values?.nextCycleOn ? "print-hidden" : ""}`}
      >
        <div className="details-general-sub-label">
          Next Cycle Date:
        </div>
        <div className="details-general-sub-value">
          {values?.nextCycleOn ? moment(values?.nextCycleOn).format("DD-MM-YYYY") : ''}
        </div>
      </div>
      {/* Tests Required */}
      <div className={`${addToPrint.testsToBeDone ? "" : "print-hidden"}`}>
        <div className="d-flex justify-content-between align-items-center">
          <div
            className={`create-heading ${values?.testsToBeDone?.some((outer: any) => {
              return outer?.tests?.some((inner: any) => inner?.testName);
            }) ? "" : "print-hidden"}`}
          >
            Tests to be Done
          </div>
          <div className="print-hidden add-to-print">
            <input
              type="checkbox"
              className="add-to-print-checkbox"
              checked={addToPrint.testsToBeDone}
              onChange={(e: any) => {
                const tempAddToPrint = { ...addToPrint }
                tempAddToPrint.testsToBeDone = !addToPrint.testsToBeDone
                setAddToPrint(tempAddToPrint)
              }}
            />
            <span>
              Add to print
            </span>
          </div>
        </div>
        <table
          className={`home-medication-table ${values?.testsToBeDone?.some((outer: any) => {
            return outer?.tests?.some((inner: any) => inner?.testName);
          }) ? "" : "print-hidden"}`}
        >
          {values?.testsToBeDone?.map((val: any, i: any) => {
            return <>
              <thead>
                <tr className={`heading-procedures ${val?.isCancelled ? "print-hidden" : ""}`}>
                  <th>Sr.no</th>
                  <th>Test</th>
                  <th>Instructions</th>
                  <th>When</th>

                </tr>
              </thead>
              {val?.tests?.map((item: any, j: any) => {
                return (
                  <tbody>
                    <tr className={`procedure-data ${val?.isCancelled ? "print-hidden" : ""}`}>
                      <td>{j + 1}</td>
                      <td>{item?.testName}</td>
                      <td>{item?.instructions}</td>
                      <td>{item?.when}</td>
                    </tr>
                  </tbody>
                )
              })}
            </>
          })}

        </table>
      </div>
      {/* Consultant Signature */}
      <div style={{ display: 'flex', columnGap: '30px' }}>
        <div className="chemo-signature-container">
          <div className="create-heading">Consultant Signature</div>
          {patientInfo?.primaryConsultantId && type === "PAST" ? <></> : <>
            <Dropdown
              className={"consultant-signature-dropdown"}
              selected={selectedSign}
              placeholder="Select Consultant Signature"
              options={consultantOptions}
              updateDropdown={(option: any) => {
                setSelectedSign(option)
              }}
            />
          </>}
          <SurveyComponent
            css={""}
            data={signatureData}
            json={signatureJson}
            onComplete={(survey: any) => {
              const data = survey.data
              setSignatureData(data)
              // handleSurveyCompletion()
            }}
            updateFlag={updateSurveyData}
            hideDot={true}
          />
        </div>
        <div className="chemo-signature-container">
          <div className="create-heading">RMO Signature</div>
          {patientInfo?.primaryConsultantId && type === "PAST" ? <></> : <>
            <div style={{ marginTop: '65px' }}></div>
          </>}
          <div>
            <SurveyComponent
              css={""}
              data={signatureDataRMO}
              json={signatureJson}
              onComplete={(survey: any) => {
                const data = survey.data
                setSignatureDataRMO(data)
                // handleSurveyCompletion()
              }}
              updateFlag={updateSurveyDataRMO}
              hideDot={true}
            />
          </div>
        </div>
      </div>
      {/* Print Buttons */}
      <div className="print-buttons">

        {values?.isCompleted === false && values?.isActive == true ? (
          <div className="print-buttons">
            <Button
              variant="primary"
              onClick={() => {
                completeChemOrder()
              }}
              className="me-5"
            >
              Complete Chemo Order
            </Button>
            <Print
              componentRef={componentRef}
              documentTitle={`Chemo Order ${patientInfo.mocId} ${patientInfo.name}`}
              buttonTitle="Print Chemo Order"
            />
          </div>
        ) : (
          <div className="print-buttons">
            <Button
              disabled={true}
              variant="primary"
              onClick={() => {
                completeChemOrder()
              }}
              className="me-5"
            >
              Complete Chemo Order
            </Button>
            <Print
              componentRef={componentRef}
              documentTitle={`Chemo Order ${patientInfo.mocId} ${patientInfo.name}`}
              buttonTitle="Print Chemo Order"
            />
          </div>
        )}


      </div>
    </div>
  )
}

export default AccordianOrderDetail
